import { render, staticRenderFns } from "./shipment-items-list.vue?vue&type=template&id=be4cfcf0&scoped=true"
import script from "./shipment-items-list.vue?vue&type=script&lang=js"
export * from "./shipment-items-list.vue?vue&type=script&lang=js"
import style0 from "./shipment-items-list.vue?vue&type=style&index=0&id=be4cfcf0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be4cfcf0",
  null
  
)

export default component.exports